var hashtag_default = {
  "fontElementMap": "Aejg9",
  "hashtag": "lvhRm"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
